import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Gauge } from '../../../Common/Charts/Gauge';
import { useRegulationChartsDataContext } from './hooks/useRegulationChartsDataContext';

export const LocationIndex = () => {
    const { chartData } = useRegulationChartsDataContext();

    return (
        <Gauge
            title={'Índice de Localização'}
            subtitle={'percentual de atendimentos identificados'}
            subtitles={chartData?.locationIndex?.map((item) => item.description) || []}
            chartData={chartData?.locationIndex || []}
            colors={defaultColors.slice(0, chartData?.locationIndex?.length) || []}
            height={400}
        />
    );
};
